<script setup>
import { router, Head, Link } from '@inertiajs/vue3';

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";
const currentUrl = location.toString();
const host = location.host;

const logoSrc = currentUrl + 'images/sos-admin-logo.svg';
const imgPathDAImpact = currentUrl + 'images/logos/da-impact-logo.png';
const imgPathFTUC = currentUrl + 'images/logos/ftuc-logo.png';
const imgPathGI = currentUrl + 'images/logos/green-impact-logo.png';
const imgPathHedgehog = currentUrl + 'images/logos/hedgehog-logo.png';
const imgPathRF = currentUrl + 'images/logos/rf-logo.png';

defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
});
</script>

<template>
    <Head title="Students Organsing for Sustainability - Toolkit Platform" />

    <div class="relative flex items-top justify-center min-h-screen bg-gray-100 dark:bg-gray-900 sm:items-center sm:pt-0">

        <div class="sm:max-w-[600px] p-10">
            <img :src="logoSrc" alt="Students Organsing for Sustainability - Toolkit Platform" class="sm:max-w-[422px] py-10"/>
            <p v-html="$t('application.welcome.content')"></p>

            <ul id="partner-logos" class="flex justify-between flex-wrap sm:max-w-[600px] py-10">
                <li class="basis-1/2">
                    <img :src="imgPathGI" :alt="$t('application.welcome.logo') + ': Green Impact'" class="py-3"/>
                    <img :src="imgPathHedgehog" :alt="$t('application.welcome.logo') + ': Hedgehog Friendly Campus'" class="py-3"/>
                    <img :src="imgPathRF" :alt="$t('application.welcome.logo') + ': Responsible Futures'" class="py-3"/>
                    <img :src="imgPathDAImpact" :alt="$t('application.welcome.logo') + ': Drug &amp; Alcohol Impact'" class="py-3"/>
                </li>
                <li class="basis-1/3">
                    <img :src="imgPathFTUC" :alt="$t('application.welcome.logo') + ': NUS Fairtrade University and College Award'" class="py-3"/>
                </li>
            </ul>

        </div>




    </div>
</template>

<style scoped>

.bg-white {
        background-color: #ffffff;
        background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
    }
    .bg-gray-100 {
        background-color: #f7fafc;
        background-color: rgba(247, 250, 252, var(--tw-bg-opacity));
    }

    .border-gray-200 {
        border-color: #edf2f7;
        border-color: rgba(237, 242, 247, var(--tw-border-opacity));
    }

    .text-gray-400 {
        color: #cbd5e0;
        color: rgba(203, 213, 224, var(--tw-text-opacity));
    }

    .text-gray-500 {
        color: #a0aec0;
        color: rgba(160, 174, 192, var(--tw-text-opacity));
    }

    .text-gray-600 {
        color: #718096;
        color: rgba(113, 128, 150, var(--tw-text-opacity));
    }

    .text-gray-700 {
        color: #4a5568;
        color: rgba(74, 85, 104, var(--tw-text-opacity));
    }

    .text-gray-900 {
        color: #1a202c;
        color: rgba(26, 32, 44, var(--tw-text-opacity));
    }

    @media (prefers-color-scheme: dark) {
        .dark\:bg-gray-800 {
            background-color: #2d3748;
            background-color: rgba(45, 55, 72, var(--tw-bg-opacity));
        }

        .dark\:bg-gray-900 {
            background-color: #1a202c;
            background-color: rgba(26, 32, 44, var(--tw-bg-opacity));
        }

        .dark\:border-gray-700 {
            border-color: #4a5568;
            border-color: rgba(74, 85, 104, var(--tw-border-opacity));
        }

        .dark\:text-white {
            color: #fff;
            color: rgba(255, 255, 255, var(--tw-text-opacity));
        }

        .dark\:text-gray-400 {
            color: #cbd5e0;
            color: rgba(203, 213, 224, var(--tw-text-opacity));
        }
    }
</style>
